
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/impact",
      function () {
        return require("private-next-pages/impact/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/impact"])
      });
    }
  